import React from 'react'
import { useState } from 'react';
import DataTable from "react-data-table-component";
import Switch from "@mui/material/Switch";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import { getApiHeader } from 'utlis/commonfunctions';
import { toast } from 'react-toastify';
import axios from "axios";
import { ThreeDots } from 'react-loader-spinner'






const SERVER_URL = process.env.REACT_APP_API_URL;


function Search({getStep}) {

    const [loading, setLoading] = useState(false);
    const [retailerData, setRetailerData] = useState([])
    const [rememberMe, setRememberMe] = useState(false);
    const [rememberMe1, setRememberMe1] = useState(false);
    const [allocateBox, setAllocateBox] = useState(false);
    const [retailerBox, setRetailerBox] = useState(false);
    const [retailerAddress, setRetailerAddress] = useState("")
    const [company, setCompany] = useState("")
    const [name, setName] = useState("")
    const [button, setButton] = useState(false)
    const [delearDetails, setDelearDetails] = useState(false)
    const [dataTable, setDataTable] = useState(false)
    const [disable, setDisable] = useState(false)
    const [toggledClearRows, setToggleClearRows] = useState(false);
    // const [selectedRows, setSelectedRows] = useState(false);
    // const[retailerDetails1,setRetailerDetails1]=useState(false);
    // const [retailerDetails, setRetailerDetails] = useState(false)


    const [formData, setFormData] = useState({
        sim_number: "",
        bundle_number: "",
        control_number: "",
        box_number: "",
        retailer_code: "",
        sim_base_ids: [],
        store_name: "",
        email: "",
        abn: "",
        state: "",
        city: "",
        postcode: "",
        street_name: "",

    });



    const handleChange = (e) => {
        setDisable(false)
        const { name, value } = e.target;

        if (name === "bundle_number") {
            setFormData({ ...formData, [name]: value });
            if (/^\d{0,20}$/.test(value)) {}
        } else if (name === 'sim_number') {
            if (/^\d{0,20}$/.test(value)) {
                setFormData({ ...formData, [name]: value });
            }
        } else {
            setFormData({
                ...formData,
                [name]: value
            });
        }
    };



    const handleSearch = async (e) => {
        e.preventDefault();
        if (!formData.sim_base_ids) {
            formData.sim_base_ids = [];
        }

        if (
            formData.sim_number === "" &&
            formData.bundle_number === "" &&
            formData.control_number === "" &&
            formData.box_number === "" &&
            formData.retailer_code === "" &&
            formData.sim_base_ids.length === 0 &&
            formData.store_name === "" &&
            formData.email === "" &&
            formData.abn === "" &&
            formData.state === "" &&
            formData.city === "" &&
            formData.postcode === "" &&
            formData.street_name === ""
        ) {
            toast.error("At least one input field must be filled");
            return;
        }

        const filteredFormData = Object.fromEntries(
            Object.entries(formData).filter(([key, value]) => value !== "" && (!Array.isArray(value) || value.length > 0))
        );

        // Check if filteredFormData is empty
        if (Object.keys(filteredFormData).length === 0) {
            toast.error("Please fill in at least one input field for searching");
            return;
        }
           setLoading(true)
        const headers = await getApiHeader();
        try {
            const response = await axios.post(`${SERVER_URL}postpaid/get_sim_stock_data`, filteredFormData, {
                headers: headers
            });
            if (response.status === 200) {
                 setLoading(false)
                setDisable(true)
                if (response.data.data.sim_bases_data !== null && response.data.data.sim_bases_data.length > 0) {
                    setDataTable(true);
                    setRetailerData(response.data.data.sim_bases_data);
                    // toast.success(response.data.message);
                    console.log("retailer-data", response.data.data.sim_bases_data);
                } else {
                    setDataTable(false);
                    setAllocateBox(false);
                    setRememberMe(false);
                    setRememberMe1(false);
                    toast.error("No data found during searching");
                }
                console.log("response", response.data.data);
            }
        } catch (error) {
            setLoading(false)
            setDisable(true)
            console.log(error);
            const errorMessage = error?.response?.data?.message || "An error occurred";
            if (typeof errorMessage === 'object') {
                Object.keys(errorMessage).forEach(key => {
                    errorMessage[key].forEach(message => {
                        toast.error(message);
                    });
                });
            } else {
                toast.error(errorMessage);
            }
        }
    };


    const handleSubmit = async (e) => {
        if (e) {
          e.preventDefault();
        }
    
        const filteredFormData = Object.fromEntries(
          Object.entries(formData).filter(([key, value]) => value !== "")
        );
        const headers = await getApiHeader();
         setLoading(true)
        try {
          const response = await axios.post(`${SERVER_URL}postpaid/get_retailer_details`, filteredFormData, {
            headers: headers
          });
          if (response.status === 200) {
            setLoading(false)
            const data = response.data.data
            setRetailerAddress(data.retailer_address)
            setCompany(data.retailer_company_name)
            setName(data.retailer_name)
            setButton(true)
            setDelearDetails(true)
            setRetailerBox(true)
            // setRetailerDetails(true)
            // setRetailerDetails1(true)
            
          
    
            console.log("data", data)
          }
          console.log("response", response.data.message);
    
        } catch (error) {
            setLoading(false)
          console.log(error)
          const errorMessage = error?.response?.data?.message || "An error occurred";
          if (typeof errorMessage === 'object') {
            Object.keys(errorMessage).forEach(key => {
              errorMessage[key].forEach(message => {
                toast.error(message);
              });
            });
    
          } else {
            toast.error(errorMessage);
          }
        }
      };



      const handleAllocate = async (e) => {
        e.preventDefault();
        setLoading(true)
        const filteredFormData = Object.fromEntries(
          Object.entries(formData).filter(([key, value]) => value !== "")
        );
        const headers = await getApiHeader();
        try {
          const response = await axios.post(`${SERVER_URL}postpaid/allocate_sim_stock`, filteredFormData, {
            headers: headers
          });
          if (response.status === 200) {
             setLoading(false)
            const data = response.data.data
            const message = response.data.message
            setAllocateBox(false);
            handleClear1()
            setFormData(prevFormData => ({
              ...prevFormData,
              retailer_code:""
            }));
            swal({
              title: "",
              text:  message ,
              icon: "success",
              button: "Close"
            });
          }
          
    
        } catch (error) {
          setButton(false)
          handleClear1()
          // setFormData(prevFormData => ({
          //   ...prevFormData,
          //   retailer_code:""
          // }));
          console.log(error)
          setLoading(false)
          const errorMessage = error?.response?.data?.message || "An error occurred";
          swal({
            title: "",
            text: errorMessage,
            icon: "error",
            button: "Close"
          });
          if (typeof errorMessage === 'object') {
            Object.keys(errorMessage).forEach(key => {
              errorMessage[key].forEach(message => {
                // toast.error(message);
              });
            });
    
          } else {
            setButton(false)
            // toast.error(errorMessage);
    
          }
        }
      };
    

















    const handleClear1=()=>{
        setFormData({
          sim_number: "",
          bundle_number: "",
          control_number: "",
          box_number: "",
          retailer_code: "",
        });
          setDataTable(false)
          setAllocateBox(false)
          setRetailerBox(false)
          setDelearDetails(false) 
          setRememberMe(false)
          setButton(false)
    
    
       }














    const styles = {
        wrapper: {
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(1px)",
            zIndex: 9999,
        },
    };


    const columns = [

        {
            id: 1,
            name: "Box Number",
            selector: (row) => row.box_number,
        },
        {
            id: 2,
            name: "Bundle Number",
            selector: (row) => row.bundle_number,
        },
        {
            id: 3,
            name: "Control Number",
            selector: (row) => row.control_number,
        },
        {
            id: 4,
            name: "Sim Number",
            selector: (row) => row.sim_number,
        },
        {
            id: 5,
            name: "Channel",
            selector: (row) => row.channel,
        },
        {
            id: 6,
            name: "Retailer ID",
            selector: (row) => row.shop_code,
        },
        {
            id: 7,
            name: "Retailer Company",
            selector: (row) => row.retailer_company_name,
        },
        {
            id: 8,
            name: "Plan Name",
            selector: (row) => row.offerName,
        },


    ];



    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };


    const handleChanges = ({ selectedRows }) => {
        const updatedSimBaseIds = selectedRows.map(row => row.sim_base_id);
        setAllocateBox(true);
        setFormData(prevFormData => ({
            ...prevFormData,
            sim_base_ids: updatedSimBaseIds
        }));
        // setSelectedRows(selectedRows);
    };


    const handleSetRememberMe = (e) => {
        setRememberMe(prevState => {
          const newRememberMeState = !prevState;
          setRetailerBox(newRememberMeState);
          return newRememberMeState;
        });
        setRememberMe1(false);
        setDelearDetails(false);
    
      };

      const handleSetRememberMe1 = (e) => {
        setRememberMe1(prevState => {
          const newRememberMe1State = !prevState;
          setSearchStore(newRememberMe1State);
          return newRememberMe1State;
        });
        setRememberMe(false);
        // setRetailerDetails(false)
        // setRetailerDetails1(false)
        setFormData(prevFormData => ({
          ...prevFormData,
          retailer_code: "",
          store_name: "",
          email: "",
          abn: "",
          state: "",
          city: "",
          postcode: "",
          street_name: "",
        }));
      };


      const handlePidChange = (e) => {
        const value = e.target.value
        setFormData({
          ...formData,
          retailer_code: value
        });
        // setPid(value)
    
      }





    const handleClearRows = () => {
        setToggleClearRows(!toggledClearRows);
    }

    const rowDisabledCriteria = row => row.shop_code;


    const customStyles = {
        gyksGC: {
            style: {
                whiteSpace: "normal",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }
        },
        fKWVwL: {
            style: {
                whiteSpace: "normal",
                overflow: "hidden",
                textOverflow: "ellipsis"
            }

        },
        rows: {
            style: {
                border: '1px solid #ccc',
            },
        },
        headCells: {
            style: {
                backgroundColor: '#f0f0f0',
                border: '1px solid #ccc',
            },
        },
        cells: {
            style: {
                border: '1px solid #ccc',
            }
        },
    };





    return (
        <div>

            {loading && (
                <div style={styles.wrapper}>
                    <ThreeDots
                        visible={loading}
                        height="80"
                        width="80"
                        color="#C11D6C"
                        radius="9"
                        ariaLabel="three-dots-loading"
                    />
                </div>
            )}
            <div className="formbold-main-wrapper">
                <div className="formbold-form-wrapper">
                    <h5 style={{ textAlign: "center" }}>Search And Allocate SIM Stock</h5>
                    <form action="" method="" onSubmit={handleSearch} autoComplete='off'>
                        <div className="formbold-mb-5 formbold-pt-3">
                            <label className="formbold-form-label formbold-form-label-2">
                            </label>
                            <div className="flex flex-wrap formbold--mx-3">
                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Box Number
                                        </label>
                                        <input
                                            type="text"
                                            name="box_number"
                                            id="box_number"
                                            placeholder="Enter Box Number"
                                            className="formbold-form-input"
                                            value={formData.box_number}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Bundle Number
                                        </label>
                                        <input
                                            type="text"
                                            name="bundle_number"
                                            id="bundle_number"
                                            placeholder="Enter Bundle Number"
                                            className="formbold-form-input"
                                            value={formData.bundle_number}
                                            onChange={handleChange}
                                            autoComplete="off"
                                            maxLength={20}
                                        />
                                    </div>
                                </div>

                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            SIM Number
                                        </label>
                                        <input
                                            type="tel"
                                            name="sim_number"
                                            id="sim_number"
                                            placeholder="Enter SIM Number"
                                            className="formbold-form-input"
                                            value={formData.sim_number}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Control Number
                                        </label>
                                        <input
                                            type="text"
                                            name="control_number"
                                            id="control_number"
                                            placeholder="Enter Control Number"
                                            className="formbold-form-input"
                                            value={formData.control_number}
                                            onChange={handleChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="w-full sm:w-half formbold-px-3">
                                    <div className="formbold-mb-5">
                                        <label htmlFor="store_name" className="formbold-form-label">
                                            Retailer ID

                                        </label>
                                        <input
                                            type="text"
                                            name="retailer_code"
                                            id="retailer_code"
                                            placeholder="Enter Retailer ID"
                                            className="formbold-form-input"
                                            value={formData.retailer_code}
                                            onChange={handleChange}
                                            autoComplete='off'
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="search-store-buttons">
                            <button className="search-store-button" type="submit" disabled={disable}><i class="fa fa-search"></i> Search</button>
                            {
                                dataTable && (
                                    <button className="search-store-button" type="button" onClick={handleClear1}>
                                        Clear
                                    </button>
                                )
                            }
                        </div>
                    </form>
                    {dataTable && (
                        <div className="data-dummy-table">
                            <DataTable
                                title="Search And Allocate Sim Stock Details"
                                columns={columns}
                                data={retailerData}
                                pagination
                                paginationComponentOptions={paginationComponentOptions}
                                selectableRows
                                onSelectedRowsChange={handleChanges}
                                clearSelectedRows={toggledClearRows}
                                selectableRowDisabled={rowDisabledCriteria}
                                customStyles={customStyles}
                            />
                        </div>
                    )}


                    {allocateBox && (
                        <div style={{ marginTop: "50px" }}>
                            <div classname="formbold-main-wrapper">
                                <div classname="formbold-form-wrapper">
                                    <div className='trail'>
                                        <div className='sub-trail'>
                                            <SoftBox display="flex" alignItems="center">
                                                <Switch checked={rememberMe} onChange={handleSetRememberMe} />
                                                <SoftTypography
                                                    variant="button"
                                                    fontWeight="regular"
                                                    onClick={handleSetRememberMe}
                                                    sx={{ cursor: "pointer", userSelect: "none" }}
                                                >
                                                    &nbsp;&nbsp;Assign directly using Retailer ID
                                                </SoftTypography>
                                            </SoftBox>

                                            <SoftBox display="flex" alignItems="center" className="second-Button">
                                                <Switch checked={rememberMe1} onChange={()=>getStep(2,formData)} />
                                                <SoftTypography
                                                    variant="button"
                                                    fontWeight="regular"
                                                    // onClick={handleSetRememberMe1}
                                                    sx={{ cursor: "pointer", userSelect: "none" }}
                                                >
                                                    &nbsp;&nbsp;Search Store and Allocate  SIM Stock
                                                </SoftTypography>
                                            </SoftBox>
                                        </div>

                                        {retailerBox && (
                                            <SoftBox component="form" role="form" style={{ width: "20%" }} mx={"5%"}>
                                                <SoftBox mb={2}>
                                                    <SoftBox>
                                                        <SoftTypography component="label" variant="caption" fontWeight="bold" style={{ fontSize: "20px" }}>
                                                            Enter Retailer ID  <span class="astrix-color">*</span>
                                                        </SoftTypography>
                                                    </SoftBox>
                                                    <SoftInput type="text" placeholder="Enter Retailer Id" name="retailer_code" value={formData.retailer_code} autoComplete='off' onChange={handlePidChange} />

                                                    {delearDetails && (
                                                        <div className='details'>
                                                            <h6 className='details-name'>Dealer Name: <span>&nbsp;</span>{name}</h6>
                                                            <h6 className='details-company'>Company/Store Name:<span>&nbsp;<span>&nbsp;</span></span>{company}</h6>
                                                            <h6 className='details-address'>Dealer Address:<span>&nbsp;</span><span>&nbsp;</span>{retailerAddress}</h6>
                                                        </div>
                                                    )}

                                                </SoftBox>
                                                {button ? (
                                                    <SoftBox mt={2} mb={2} style={{ paddingBottom: "60px" }}>
                                                        <SoftButton variant="gradient" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleAllocate}>
                                                            Allocate
                                                        </SoftButton>
                                                    </SoftBox>
                                                ) : (
                                                    <SoftBox mt={2} mb={2} style={{ paddingBottom: "60px" }}>
                                                        <SoftButton variant="gradient" style={{ backgroundColor: "#C11D6C", color: "white" }} onClick={handleSubmit}>
                                                            Search
                                                        </SoftButton>
                                                    </SoftBox>
                                                )}
                                            </SoftBox>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Search